import { combineReducers } from 'redux'
//import {persistentReducer} from 'redux-pouchdb' // pouchdb
import {
  RECEIVE_ACTIVITY,
  RECEIVE_COMPETENCY,
  RECEIVE_ANSWER
} from './actions'


export function competencies(state={},action) {
  switch(action.type) {
    case RECEIVE_COMPETENCY:
      return Object.assign({}, state, { [action.competencyId]: action.competency }   )
    case RECEIVE_ANSWER:
      const competency = state[action.competencyId]
      const dimension = competency.dimensions[action.dimensionId]
      if (!competency.answers) competency.answers = {}
      competency.answers[action.dimensionId + action.answer.indicatorId] = 
        dimension.indicators[action.answer.indicatorId].text
      return Object.assign({},state, {[action.competencyId]: competency })
    default:
      return state
  }
}

const rootReducer = combineReducers({
  competencies
})

export default rootReducer
//export default persistentReducer(postsBySubreddit,'postsBySubreddit')


// WEBPACK FOOTER //
// ./src/modules/competencies/reducers.js